import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { Button } from 'primereact/button';
import toggleBasketModal from '../store/actions/basketToggle';
import closeIcon from '../assets/icons/closeIcon.svg';
import useWindowSize from '../hooks/useWindowSize';
import BasketModalItem from './BasketModalItem';
import { removeFromLocalBasket, removeFromUserBasket } from '../store/actions/basketActions';
import toggleRegisterForm from '../store/actions/registerFormToggle';
// import { removeFromLocalBasket } from '../store/actions/basketActions';

const height = localStorage.getItem('HeaderHeight');

function BasketModal() {
  const sidebarRef = useRef(null);
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const { isAuth, token } = useSelector((state) => state.users);
  const localBasket = useSelector((state) => state.basketReducers.localBasket);
  const userBasket = useSelector((state) => state.users.cart);
  const { translations } = useSelector((state) => state.translation);
  const visible = useSelector((state) => state.basketToggle.visible);
  const handleCloseModal = () => {
    dispatch(toggleBasketModal({ visible: false }));
  };
  const handleBooking = () => {
    if (isAuth) {
      navigate(`/${lang}/check-out`);
      handleCloseModal();
    } else {
      navigate(`/${lang}`);
      dispatch(toggleBasketModal({ visible: false }));
      dispatch(toggleRegisterForm({ visible: true, type: 'login' }));
    }
  };
  const handleDeleteFromBasket = async (id) => {
    if (!isAuth) {
      const basket = JSON.parse(localStorage.getItem('basket')) || [];
      localStorage.setItem('basket', JSON.stringify(basket.filter((item) => item.id !== id)));
      dispatch(removeFromLocalBasket(id));
      toast(translations?.deleted?.[lang]);
    } else {
      const { payload } = await dispatch(removeFromUserBasket({ id, token }));
      if (payload.message === 'Cart deleted') {
        toast(translations?.deleted?.[lang]);
      }
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        dispatch(toggleBasketModal(false));
      }
    };
    if (visible) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);
  return (
    <>
      {visible && <div role="presentation" className="mask" onClick={handleCloseModal} />}
      <div
        style={{
          height: width < 768 ? `calc(100% - ${height}px)` : '100vh',
        }}
        className={`sidebar ${visible ? 'visible' : ''}`}
        ref={sidebarRef}
      >
        <div className="basket">
          <div className="basket-header">
            <div className="basket-title">{translations?.my_cart?.[lang]}</div>
            <button type="button" className="close-button" onClick={handleCloseModal}>
              <img src={closeIcon} alt="close" />
            </button>
          </div>
          <div className="basket-items">
            {isAuth ? (
              userBasket.map((e) => (
                <BasketModalItem
                  handleDeleteFromBasket={handleDeleteFromBasket}
                  key={e.id}
                  id={e.id}
                  price={e.price}
                  title={e.name}
                />
              ))
            ) : (
              localBasket.map((item) => (
                <BasketModalItem
                  handleDeleteFromBasket={handleDeleteFromBasket}
                  key={item.id}
                  id={item.id}
                  price={item.price[lang]}
                  title={item.title[lang]}
                />
              ))
            )}
          </div>
          <div className="basket-footer">
            <div className="basket-footer-total">
              <p className="basket-footer-total-title">{translations?.total?.[lang]}</p>
              <p className="basket-footer-total-price">
                {isAuth ? userBasket.reduce((acc, item) => acc + +item.price, 0)
                  : localBasket.reduce((acc, item) => acc + +item.price[lang], 0)}
                {' '}
                {translations?.amd?.[lang]}
              </p>
            </div>
            <div className="basket-modal-actions">
              {width < 768 && (
              <button
                onClick={handleCloseModal}
                type="button"
                className="basket-footer-btn cancel"
              >
                {translations?.cancel?.[lang]}
              </button>
              )}
              <Button
                disabled={isAuth ? userBasket.length === 0 : localBasket.length === 0}
                onClick={handleBooking}
                type="button"
                className="basket-footer-btn"
              >
                {translations?.checkout?.[lang]}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BasketModal;
